module.exports = __webpack_public_path__ + "img/projects_blue.d7eaa14f.svg";